import { render, staticRenderFns } from "./TypographyPresetChooserInput.vue?vue&type=template&id=75a1e5fa&"
import script from "./TypographyPresetChooserInput.vue?vue&type=script&lang=ts&"
export * from "./TypographyPresetChooserInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports